import script from "./Upload.vue?vue&type=script&setup=true&lang=ts"
export * from "./Upload.vue?vue&type=script&setup=true&lang=ts"

import "./Upload.vue?vue&type=style&index=0&id=a0f99504&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0f99504"]])

export default __exports__